import { css } from 'linaria';

export const featuresSection = css`
  display: grid;
  grid-template-columns: repeat(5, 210px);
  width: 100%;
  margin-bottom: 80px;
  column-gap: 32px;

  @media (--only-desktop) {
    grid-template-columns: repeat(5, 172px);
    column-gap: 24px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(3, 210px);
    margin-bottom: 64px;
    column-gap: 24px;
    row-gap: 32px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    margin-bottom: 48px;
    row-gap: 32px;
  }
`;

export const feature = css`
  display: flex;
  flex-direction: column;

  @media (--only-mobile) {
    flex-direction: row;
  }
`;

export const featureIcon = css`
  width: 72px;
  height: 72px;
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-right: 16px;
    margin-bottom: 0;
  }
`;

export const featureText = css`
  @media (--only-tablet) {
    line-height: 22px;
  }

  @media (--only-mobile) {
    line-height: 18px;
  }
`;
